import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { I_competition_entry } from '../../models/i_competition_entry.interface';
import { Horse_show_entry_with_type } from '../../models/horse_show_entry_with_type';
import { Person } from '../../models/person';
import { Entry_type } from '../../models/entry_type';

import { PendingHorseShowEntryService } from '../../providers/pending-horse-show-entry.service';
import { PendingCompetitionEntryService } from '../../providers/pending-competition-entry.service';

import { SmsAbstractAppPage } from '../sms-abstract-app-page';

import { faUser, faSpinner, faTrash } from '@fortawesome/fontawesome-pro-regular';
import {AccountEntryView} from '../../models/account_entry_view';
import {EntryTypeService} from '../../providers/entry-type.service';
import {Horse_show_entry} from '../../models/horse_show_entry';

@Component({
  standalone: false,
  selector: 'app-modal-edit-competitions',
  templateUrl: './modal-edit-competitions.component.html',
styleUrls:  ['./modal-edit-competitions.component.css']
})
export class ModalEditCompetitionsComponent  extends SmsAbstractAppPage implements OnInit {

  pending_competition_entry_added$: EventEmitter<I_competition_entry> = new EventEmitter<I_competition_entry>();
  pending_competition_entry_removed$: EventEmitter<I_competition_entry> = new EventEmitter<I_competition_entry>();

  rider_list: Person[] = [];

  horseShowEntry: Horse_show_entry = null;

  entry_type: Entry_type = null;

  faUser = faUser;
  faSpinner = faSpinner;
  faTrash = faTrash;

  loading: boolean;

  constructor(public activeModal: NgbActiveModal,
    private entryTypeService: EntryTypeService,
  	private pendingCompetitionEntryService: PendingCompetitionEntryService,
  	private pendingHorseShowEntryService: PendingHorseShowEntryService) {
  	super();
  }

  ngOnInit() {
  	this.loading = true;
  }

  setHorse_show_entry(entryView: AccountEntryView){

    //Reload entry
  	this.pendingHorseShowEntryService.getWithCompetitionsOnly(entryView.entryId).then(horse_show_entry => {
      this.horseShowEntry = horse_show_entry;
  		this.rider_list = horse_show_entry.rider_list;

      this.entryTypeService.get(horse_show_entry.horse_show_id, horse_show_entry.entry_type).then(entryType => {
        this.entry_type = entryType;
      }).catch(error => {
        this.handleError(error);
      });

  		this.loading = false;
  	}).catch(error => {
  		this.loading = false;
  		this.handleError(error);
  	});
  }

  onCompetitionEntered(competition_entry: I_competition_entry){
  	this.pendingCompetitionEntryService.create(competition_entry).then(new_competition_entry => {

  		this.horseShowEntry.pending_competition_entry_list.push(new_competition_entry);

  		this.horseShowEntry.pending_competition_entry_list.sort((a_comp_entry, b_comp_entry) => {
  			if(a_comp_entry.competition_number > b_comp_entry.competition_number) {
  				return 1;
  			} else if(a_comp_entry.competition_number < b_comp_entry.competition_number){
  				return -1;
  			} else {
  				return 0;
  			}
  		});

  		this.pending_competition_entry_added$.emit(new_competition_entry);
  	}).catch(error => {
  		this.handleError(error);
  	});
  }


  handleRemoveCompetition(competition_entry: I_competition_entry){
  	this.pendingCompetitionEntryService.delete(competition_entry).then(result => {
      if(result){
        this.horseShowEntry.pending_competition_entry_list.forEach((cmp_ent, i) =>{
          if(cmp_ent.id == competition_entry.id){
            this.horseShowEntry.pending_competition_entry_list.splice(i, 1);
          }
        });
        this.pending_competition_entry_removed$.emit(competition_entry);
      }
  	}).catch(error => {
  		this.handleError(error);
  	});

  }

}
